// extracted by mini-css-extract-plugin
module.exports = {"modalSpinner":"az_Sr","dialog":"az_Tr"};